import Bowser from 'bowser';

// 浏览器解析器实例
export const browser = Bowser.getParser(window.navigator.userAgent);

// 平台类型检测
export const isMobile = browser.getPlatformType() === 'mobile';
export const isTablet = browser.getPlatformType() === 'tablet';
export const isDesktop = browser.getPlatformType() === 'desktop';

// 浏览器类型检测
export const isSafari = browser.getBrowserName(true) === 'safari';
export const isChrome = browser.getBrowserName(true) === 'chrome';
export const isFirefox = browser.getBrowserName(true) === 'firefox';
export const isEdge = browser.getBrowserName(true) === 'microsoft edge';
export const isOpera = browser.getBrowserName(true) === 'opera';

export const isMac = browser.getOSName(true) === 'macos';
export const isWin = browser.getOSName(true) === 'windows';
export const isIOS = browser.getOSName(true) === 'ios';
export const isAndroid = browser.getOSName(true) === 'android';
export const isLinux = browser.getOSName(true) === 'linux';

// 浏览器版本信息
export const browserVersion = browser.getBrowserVersion();
export const browserName = browser.getBrowserName();

// 操作系统信息
export const osName = browser.getOSName();
export const osVersion = browser.getOSVersion();

// 实用组合判断
export const isMobileOrTablet = isMobile || isTablet;
export const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
